var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlecheHaut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_48",
    "data-name": "Groupe 48",
    transform: "translate(-102 -572)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 80,
    height: 80,
    transform: "translate(102 572)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_42",
    "data-name": "Groupe 42",
    transform: "translate(114 580)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.227)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 5.779)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 5.779)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 5.779)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.114 11.558)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 11.558)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 11.558)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 11.558)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 11.558)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.896 11.558)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 17.337)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.114 17.337)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 17.337)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 17.337)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 17.337)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 17.337)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.896 17.337)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_569",
    "data-name": "Rectangle 569",
    width: 5.779,
    height: 5.779,
    transform: "translate(44.23 17.337)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_570",
    "data-name": "Rectangle 570",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.114 23.115)",
    fill: "#ffdb80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.896 23.115)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 5.779,
    height: 5.779,
    transform: "translate(44.23 23.115)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 5.779,
    height: 5.779,
    transform: "translate(50.009 23.115)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_580",
    "data-name": "Rectangle 580",
    width: 5.779,
    height: 5.779,
    transform: "translate(0 28.894)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_581",
    "data-name": "Rectangle 581",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_582",
    "data-name": "Rectangle 582",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.114 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_583",
    "data-name": "Rectangle 583",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_584",
    "data-name": "Rectangle 584",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_585",
    "data-name": "Rectangle 585",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 28.894)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_586",
    "data-name": "Rectangle 586",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_587",
    "data-name": "Rectangle 587",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.896 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_588",
    "data-name": "Rectangle 588",
    width: 5.779,
    height: 5.779,
    transform: "translate(44.23 28.894)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_589",
    "data-name": "Rectangle 589",
    width: 5.779,
    height: 5.779,
    transform: "translate(50.009 28.894)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 5.779,
    height: 5.779,
    transform: "translate(5.779 34.673)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_591",
    "data-name": "Rectangle 591",
    width: 5.779,
    height: 5.779,
    transform: "translate(11.114 34.673)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_592",
    "data-name": "Rectangle 592",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 34.673)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_593",
    "data-name": "Rectangle 593",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 34.673)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_594",
    "data-name": "Rectangle 594",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 34.673)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_595",
    "data-name": "Rectangle 595",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 34.673)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_596",
    "data-name": "Rectangle 596",
    width: 5.779,
    height: 5.779,
    transform: "translate(38.896 34.673)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_597",
    "data-name": "Rectangle 597",
    width: 5.779,
    height: 5.779,
    transform: "translate(44.23 34.673)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_598",
    "data-name": "Rectangle 598",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 40.452)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_599",
    "data-name": "Rectangle 599",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 40.452)",
    fill: "#ffc942"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_600",
    "data-name": "Rectangle 600",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 40.452)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_601",
    "data-name": "Rectangle 601",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 40.452)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_602",
    "data-name": "Rectangle 602",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_603",
    "data-name": "Rectangle 603",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_604",
    "data-name": "Rectangle 604",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 46.23)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_605",
    "data-name": "Rectangle 605",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 46.23)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_606",
    "data-name": "Rectangle 606",
    width: 5.779,
    height: 5.779,
    transform: "translate(16.67 52.009)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_607",
    "data-name": "Rectangle 607",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 52.009)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_608",
    "data-name": "Rectangle 608",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 52.009)",
    fill: "#ffb342"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    width: 5.779,
    height: 5.779,
    transform: "translate(22.226 57.788)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_610",
    "data-name": "Rectangle 610",
    width: 5.779,
    height: 5.779,
    transform: "translate(27.783 57.788)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_611",
    "data-name": "Rectangle 611",
    width: 5.779,
    height: 5.779,
    transform: "translate(33.34 52.009)",
    fill: "#3d3d3d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlecheHaut);
export default __webpack_public_path__ + "static/media/fleche_haut.bd384c2d3f56c2f0fc9afd3fdd6b6439.svg";
export { ForwardRef as ReactComponent };